
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.001 6.645a6.463 6.463 0 01-1.25 3.827l3.956 3.951a.998.998 0 010 1.413c-.39.39-1.025.39-1.415 0l-3.957-3.952a6.471 6.471 0 01-3.834 1.248c-3.59 0-6.5-2.904-6.5-6.487 0-3.584 2.91-6.488 6.5-6.488s6.5 2.904 6.5 6.488zm-6.5 4.49A4.508 4.508 0 009.683 9.82a4.49 4.49 0 00.975-4.894 4.49 4.49 0 00-2.435-2.43 4.508 4.508 0 00-4.904.973 4.49 4.49 0 00-.975 4.894 4.49 4.49 0 002.435 2.43 4.508 4.508 0 001.722.343z","fill":"#1870B8"}})])
          )
        }
      }
    